import { render, staticRenderFns } from "./security-contact.vue?vue&type=template&id=2c7281d8&scoped=true&"
import script from "./security-contact.vue?vue&type=script&lang=tsx&"
export * from "./security-contact.vue?vue&type=script&lang=tsx&"
import style0 from "./security-contact.vue?vue&type=style&index=0&id=2c7281d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7281d8",
  null
  
)

export default component.exports